import Backbone from 'backbone'
import template from './licensed-database.hbs'
import config from 'scoreboard/components/config'
import groupUsageItem from './group-usage-item.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import Slider from 'scoreboard/components/slider'
import groupType from 'scoreboard/admin/principals/groups/group-type'

function buildUsageHtml(label, usage, max, cssClass) {
	return groupUsageItem({
		typeAndMax: label,
		usage,
		max: Math.max(max,usage),	//#13087/#25837  show beyond when max exceeded
		extraClass: cssClass
	})
}

var LicensedDatabase = Backbone.View.extend({

	// this.options.license is the license
	// this.usage is the license usage for this database within its license

	className: 'licensed-database',

	initialize: function(options) {
		this.options = options || {}
		this.usage = this.options.usage
		this._license = this.options.license
	},

	render: function() {
		var context = {
			label: this.usage.dbInfo.label
		}
		this.$el.empty().append(template(context))
		var html = ''

		// #9147 view only groups can have an unlimited number of users,
		// but we need to pick some sort of max to display the slider
		// properly, so just choose the maximum of all the different
		// possible group types
		let aggregateTotal = _.max(this.usage.maximum)

		let licenseModel = this._license.licenseModel
		if (licenseModel == 'cms') {
			_.each(groupType.messageKeysByType(this._license), (labelCode, type) => {
				let isNonViewerGroup = type != 'active-viewers'
				let label = i18n.get('admin.licenseUsage.viewers')
				let used = this.usage.usedByGroupType[type]
				let max = aggregateTotal
				let extraClass = ''

				if (isNonViewerGroup) {
					//if non viewer, use the max of that group type
					max = this.usage.maximumByGroupType[type]
					label = `${i18n.get(labelCode)} (${max})`

					// #18828 account for borrowing from higher slots
					let borrowed = this.usage.borrowedByGroupType[type]
					let reassigned = this.usage.reassignedByGroupType[type]
					let totalUsed = used + reassigned - borrowed
					if (totalUsed > max) {
						extraClass = 'slider-danger'
					} else if (borrowed > 0) {
						extraClass = 'slider-warning'
					}
				}
				html += buildUsageHtml(label, used, max, extraClass)
			})
		} else {
			let {totalStandardSeats, usedStandardSeats, availableStandardSeats,
				totalViewOnlySeats, availableViewOnlySeats} = this.usage
			let extraClass = availableStandardSeats < 0 ? 'slider-danger' : ''
			let label = `${i18n.get('admin.licenseUsage.standardUsage')} (${totalStandardSeats})`
			html += buildUsageHtml(label, usedStandardSeats, totalStandardSeats, extraClass)

			//impact introduces a view only seat type
			if (licenseModel == 'impact') {
				let viewOnlyUsed = this.usage.usedByGroupType['view-only']
				if (this.usage.unlimitedViewOnly) {
					let label = i18n.get('admin.licenseUsage.viewOnlyUnlimited')
					html += buildUsageHtml(label, viewOnlyUsed, aggregateTotal, '')
				} else {
					label = `${i18n.get('admin.licenseUsage.viewOnlyUsage')} (${totalViewOnlySeats})`
					extraClass = ''
					if (availableStandardSeats < 0 && availableViewOnlySeats < 0) {
						extraClass = 'slider-danger'
					} else if (this.usage.borrowedByGroupType['view-only'] > 0) {
						extraClass = 'slider-warning'
					}
					html += buildUsageHtml(label, viewOnlyUsed, totalViewOnlySeats, extraClass)
				}
			}
		}

		// Remove line breaks from the content so the inline-block
		// items can sit next to each other without wrapping
		html = html.replace(/(\r\n|\n|\r)/gm,'')

		this.$('.group-usage .database-row').html(html)

		this.sliders = []
		this.$('input[type=number]').each(function(index, el) {
			this.sliders.push(new Slider({ input: el }).render())
		}.bind(this))
		if (this.options.license.daysUntilExpiration < 0) {
			this.$('.slider').addClass('slider-gray')
		}

		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.sliders, 'remove')
	}

})

export default LicensedDatabase

LicensedDatabase.__filename__ = 'admin/licenses/licensed-database.js'
